import { useState } from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import {
  setConsent,
  getStoredConsent,
  isAnalyticsActive,
  type ConsentChoice,
} from 'src/utils/analytics';

import { neutralDark, neutralLight } from 'src/theme/palette';

import { Button } from 'src/components/button';

// GDPR cookie banner. Shown once until the user chooses; analytics stays opted
// out until "Accept". Only rendered when analytics actually loaded.
export function CookieConsent() {
  const [decided, setDecided] = useState(() => !isAnalyticsActive() || getStoredConsent() !== null);

  if (decided) return null;

  const choose = (choice: ConsentChoice) => {
    setConsent(choice);
    setDecided(true);
  };

  return (
    <Box
      role="dialog"
      aria-label="Cookie consent"
      sx={{
        position: 'fixed',
        bottom: { xs: 8, md: 16 },
        left: { xs: 8, md: 16 },
        right: { xs: 8, md: 16 },
        mx: 'auto',
        maxWidth: 520,
        zIndex: (theme) => theme.zIndex.snackbar,
        p: 2.5,
        borderRadius: '16px',
        backgroundColor: neutralLight.lightest,
        border: `1px solid ${neutralLight.dark}`,
        boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.12)',
      }}
    >
      <Stack spacing={2}>
        <Typography sx={{ fontSize: 14, lineHeight: 1.5, color: neutralDark.darkest }}>
          We use analytics cookies to understand how our app is used so we can improve it. You can
          accept or decline — declining won&apos;t affect your experience.
        </Typography>
        <Stack direction="row" spacing={1.5} sx={{ justifyContent: 'flex-end' }}>
          <Button variant="tertiary" onClick={() => choose('rejected')}>
            Decline
          </Button>
          <Button variant="primary" onClick={() => choose('accepted')}>
            Accept
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
}
